(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Testimonials"] && !Shopify.designMode) return;
  try {
    
function toggleText(button) {
    const textContent = button.previousElementSibling;
    const isExpanded = textContent.classList.contains('expanded');
    if (isExpanded) {
        textContent.classList.remove('expanded');
        textContent.style.display = '-webkit-box';
        textContent.style.webkitLineClamp = '3';
        textContent.style.webkitBoxOrient = 'vertical';
        textContent.style.overflow = 'hidden';
        button.textContent = 'Read more';
    } else {
        textContent.classList.add('expanded');
        textContent.style.display = 'block';
        textContent.style.webkitLineClamp = 'unset';
        textContent.style.overflow = 'visible';
        button.textContent = 'Read less';
    }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zsp-drivers"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-zsp-drv]').forEach(function (g) {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      var dots = g.parentNode.querySelectorAll('.zsp-drv__dots button');
      g.addEventListener('scroll', function () {
        var w = g.scrollWidth - g.clientWidth, n = w <= 0 ? 0 : Math.round(g.scrollLeft / w * 2);
        if (String(n) === g.dataset.i) return; g.dataset.i = n;
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
      }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { g.scrollTo({ left: (g.scrollWidth - g.clientWidth) * k / 2, behavior: 'smooth' }); }); });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zsp-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-zsp-faq]').forEach(function (list) {
      if (list.dataset.ready) return; list.dataset.ready = '1';
      list.addEventListener('click', function (e) {
        var q = e.target.closest('.zsp-faq__q');
        if (q) {
          var item = q.parentNode, open = !item.classList.contains('is-open');
          list.querySelectorAll('.zsp-faq__item.is-open').forEach(function (o) { o.classList.remove('is-open'); o.querySelector('.zsp-faq__q').setAttribute('aria-expanded', 'false'); });
          if (open) { item.classList.add('is-open'); q.setAttribute('aria-expanded', 'true'); }
          return;
        }
        var m = e.target.closest('.zsp-faq__more');
        if (m) {
          var all = list.classList.toggle('is-all');
          m.setAttribute('aria-expanded', all ? 'true' : 'false');
          m.querySelector('span').textContent = all ? m.dataset.less : m.dataset.more;
          if (!all) list.querySelectorAll('.zsp-faq__item.is-extra.is-open').forEach(function (o) { o.classList.remove('is-open'); });
        }
      });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { var it = e.target.closest && e.target.closest('.zsp-faq__item'); if (!it) return; var l = it.parentNode; l.classList.add('is-all'); it.classList.add('is-open'); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zsp-how"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function slider(box) {
    if (box.dataset.ready) return; box.dataset.ready = '1';
    var track = box.querySelector('.zsp-how__track'), n = track.children.length, i = 0, hold = 0, x0 = null;
    function go(k) { i = (k + n) % n; track.style.transform = 'translateX(' + (-i * 100) + '%)'; }
    function user(k) { hold = Date.now() + 12000; go(k); }
    box.querySelectorAll('.zsp-how__arr').forEach(function (b) { b.addEventListener('click', function () { user(i + +b.dataset.dir); }); });
    box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) > 40) user(i + (dx < 0 ? 1 : -1)); });
    if (box.dataset.autoplay === 'true' && !reduce && n > 1) setInterval(function () { if (Date.now() > hold) go(i + 1); }, (+box.dataset.interval || 6) * 1000);
    document.addEventListener('shopify:block:select', function (e) { var k = Array.prototype.indexOf.call(track.children, e.target); if (k > -1) user(k); });
  }
  function money(el) {
    if (el.dataset.ready) return; el.dataset.ready = '1';
    if (reduce || !('IntersectionObserver' in window)) return;
    var total = +el.dataset.total || 0, amt = el.querySelector('[data-amt]');
    el.classList.add('is-wait'); amt.textContent = '₹0';
    var io = new IntersectionObserver(function (es) {
      if (!es.some(function (e) { return e.isIntersecting; })) return; io.disconnect();
      setTimeout(function () { var t0 = Date.now(); var t = setInterval(function () { var p = Math.min(1, (Date.now() - t0) / 700); amt.textContent = '₹' + Math.round(total * (1 - Math.pow(1 - p, 3))); if (p >= 1) clearInterval(t); }, 30); }, 300);
      setTimeout(function () { el.classList.add('lit-a'); }, 1900);
      setTimeout(function () { el.classList.add('lit-b'); }, 2900);
    }, { threshold: .12 });
    io.observe(el);
  }
  function init(root) { root = root || document; root.querySelectorAll('[data-zsp-how]').forEach(slider); root.querySelectorAll('[data-zsp-money]').forEach(money); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zsp-what"] && !Shopify.designMode) return;
  try {
    
(function () {
  var SEQ = ['73915826407319582640', '58204719365820471936', '94618273059461827305', '36184950273618495027'];
  function init(root) {
    var wrap = (root || document).querySelectorAll('[data-zsp-facts]');
    wrap.forEach(function (w) {
      if (w.dataset.ready) return; w.dataset.ready = '1';
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;
      var cols = [];
      w.querySelectorAll('.zsp-fact__n').forEach(function (el, i) {
        var v = el.dataset.n || '', last = v.slice(-1);
        if (!/[0-9]/.test(last)) return;
        var digits = (SEQ[i % 4] + last).split('');
        var col = document.createElement('span'); col.className = 'zsp-reel__col';
        digits.forEach(function (d) { var s = document.createElement('span'); s.textContent = d; col.appendChild(s); });
        var reel = document.createElement('span'); reel.className = 'zsp-reel'; reel.setAttribute('aria-hidden', 'true'); reel.appendChild(col);
        el.textContent = v.slice(0, -1); el.appendChild(reel);
        cols.push({ col: col, n: digits.length - 1, i: i });
      });
      var io = new IntersectionObserver(function (es) {
        if (!es.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        cols.forEach(function (c) { c.col.style.transition = 'transform ' + (1700 + c.i * 350) + 'ms cubic-bezier(.12,.72,.18,1) ' + (c.i * 120) + 'ms'; c.col.style.transform = 'translateY(-' + c.n + 'em)'; });
      }, { threshold: .45 });
      io.observe(w);
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
